export const FETCH_RATES_BY_ORDER_SUCCESS = 'FETCH_RATES_BY_ORDER_SUCCESS';
export const FETCH_RATES_BY_ORDER_REQUEST = 'FETCH_RATES_BY_ORDER_REQUEST';
export const FETCH_RATES_BY_ORDER_FAILURE = 'FETCH_RATES_BY_ORDER_FAILURE';
export const fetchRatesByOrderSuccess = (payload) => ({
    type: FETCH_RATES_BY_ORDER_SUCCESS,
    payload,
});
export const fetchRatesByOrderRequest = (payload) => ({
    type: FETCH_RATES_BY_ORDER_REQUEST,
    payload,
});
export const fetchRatesByOrderFailure = (error) => ({
    type: FETCH_RATES_BY_ORDER_FAILURE,
    payload: error,
});
